var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureFunction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    role: "presentation",
    "data-slug-id": "functions",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "functions_fe5ed3b3-9c39-4295-8c7e-8b1e63bf12a9-6a7681ce",
    x1: -64.1,
    y1: -140.7,
    x2: -64.1,
    y2: -156.2,
    gradientTransform: "translate(83.11 161.61) scale(1.16 1.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fea11b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fea51a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#feb018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffc314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd70f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5,13.1l-.6.6a.3.3,0,0,1-.4,0L.2,9.4a.61.61,0,0,1,0-.8L.7,8h0l4.8,4.8c0,.1.1.2,0,.3Z",
    fill: "#50e6ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8,4.3l.6.6a.3.3,0,0,1,0,.4L.8,9.9h0L.2,9.3a.61.61,0,0,1,0-.8h0L4.5,4.2A.37.37,0,0,1,4.8,4.3Z",
    fill: "#1490df"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3,8l.6.6a.61.61,0,0,1,0,.8l-4.4,4.4a.3.3,0,0,1-.4,0h0l-.6-.6a.3.3,0,0,1,0-.4h0Z",
    fill: "#50e6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,9.3l-.6.6h0L12.5,5.2a.3.3,0,0,1,0-.4h0l.6-.6a.3.3,0,0,1,.4,0h0l4.3,4.3A.61.61,0,0,1,17.8,9.3Z",
    fill: "#1490df"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3,9.9H4.7a.22.22,0,0,1-.2-.2V9.6L8.8,1.1c.1,0,.1-.1.2-.1h4.2a.22.22,0,0,1,.2.2v.1L8.4,8h4.9a.22.22,0,0,1,.2.2c0,.1,0,.1-.1.1h0L5.2,16.8c-.1,0-.6.5-.4-.2h0Z",
    fill: "url(#functions_fe5ed3b3-9c39-4295-8c7e-8b1e63bf12a9-6a7681ce)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureFunction);
export default __webpack_public_path__ + "static/media/AzureFunction.5028c5f9c54337e35cb8eaf3157eb7c2.svg";
export { ForwardRef as ReactComponent };